/**
 * Normalize workflow variable maps from GET /api/workflow/:id.
 * Angular uses the `keyvalue` pipe on `recipient_variables` / `available_variables`.
 * The API may return an object, a JSON string, or a list of { key, value }.
 */
export function normalizeWorkflowVariables(raw: unknown): Record<string, string> {
  if (raw == null || raw === '') return {}

  if (typeof raw === 'string') {
    try {
      return normalizeWorkflowVariables(JSON.parse(raw) as unknown)
    } catch {
      return {}
    }
  }

  if (Array.isArray(raw)) {
    const out: Record<string, string> = {}
    for (const item of raw) {
      if (!item || typeof item !== 'object') continue
      const row = item as Record<string, unknown>
      if ('key' in row) {
        out[String(row.key)] = row.value == null ? '' : String(row.value)
        continue
      }
      const entries = Object.entries(row)
      if (entries.length === 1) {
        const [k, v] = entries[0]
        out[String(k)] = v == null ? '' : String(v)
      }
    }
    return out
  }

  if (typeof raw === 'object') {
    const out: Record<string, string> = {}
    for (const [key, value] of Object.entries(raw as Record<string, unknown>)) {
      out[key] = value == null ? '' : String(value)
    }
    return out
  }

  return {}
}
